import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5ja2cf4hvd: FaireBrandEntity = {
  token: "b_5ja2cf4hvd",
  type: "brand",
  name: "Egg Back Home USA",
  avatarUrl:
    "https://cdn.faire.com/fastly/95ce5487490345488da46178b1719ea767cdd8f0c8f9b2db29ce5a2b1c70b961.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7c18eaccea2814a595e0ff7255ac08864814c95f29f3c031be1b6f713c4d3172.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/95ce5487490345488da46178b1719ea767cdd8f0c8f9b2db29ce5a2b1c70b961.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7c18eaccea2814a595e0ff7255ac08864814c95f29f3c031be1b6f713c4d3172.jpeg",
  location: "Sheridan, WY, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "A Business Built by Women\nWith Lot's of Love\n\nEvery piece is made with passion, laughter, and probably too much coffee\n\n\nWe make pieces that brings\na little extra happiness to your everyday.\n\nHandmade in Portugal, crafted by real people (not machines!), and designed to make you smile.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:16.807Z",
    importedBy: "entity-db-cli",
  },
};
